import { useContext, useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import FdlButton from "../../buttons/FdlButton";
import FormField from "../../formfield/FormField";

import { Modal } from "@mui/material";
import { Box } from "@mui/system";

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import ProjectContext from "../../../contexts/ProjectContext";
import {useFetch} from '../../../components/auth/useFetch';

let oldLabel = null;
let oldID = null;

export default function EditCanvasModal(props) {
    const projectContext = useContext(ProjectContext);

    const { open, handleClose, cameraName, cameraData, setCameraData } = props
    const [manufacturer, setManufacturer] = useState('');
    const [camera, setCamera] = useState('');
    const [resolutionData, setResolutionData] = useState('');
    const [resolutionX, setResolutionX] = useState('');
    const [resolutionY, setResolutionY] = useState('');
    const [effectiveX, setEffectiveX] = useState('');
    const [effectiveY, setEffectiveY] = useState('');
    const [anamorphic, setAnamorphic] = useState(1);
    const [formErrorText, setFormErrorText] = useState('');
    const fetchWithAuth = useFetch()

    let canvases = {};

    
    // Preven the below from running when the modal is created (on the full form page load)
    if (Object.keys(cameraName) != 0){
    // Search camera data for the camera name of the camera being edited in this modal
    // record the current name of the camera so that we can use it
    // in our submit verification request.
    // This allows the verification endpoint to allow us to submit an edit for this camera
    // even if the edited data contains the same camera label as the camera initially had.
    // Previously the verification endpoint would detect this as 'Camera label already exists', which
    // is faulty behaviour.
        if (Object.keys(cameraData) != 0){
            oldLabel = cameraData[cameraName]['Camera Label']
        }
    }
    

    const modalPosition = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };
    
    const modalContainer = {
        bgcolor: 'black',
        border: '2px solid #000',
        boxShadow: 24,
        borderRadius: 8,
        p: 4,
        width: '60%',
        maxWidth: '700px',
        height: '80vh',
        overflow: 'auto'
    };
    
    const cancelButtonStyle = {
        backgroundColor: 'red'
    };
    
    const bottomButtonContainer = {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
    };

    const formErrorTextStyle = {
        opacity: formErrorText? 0.7 : 0,
        width: '70%',
        marginTop: '15px'
    }

    if (cameraData[cameraName] !== undefined) {
        canvases = cameraData[cameraName];
        // setManufacturer(canvases["Camera Manufacturer"]);
        // setCamera(canvases["Camera Model"]);
        // setResolutionData(canvases["Camera Resolution"]);
    } else {
        canvases = {};
    };

    // Get resolution dimension ints from database
    // Do this only when resolutionData changes
    useEffect(() => {
        // When we have a Camera Resolution set, autofill fields Resolution X and Y
        getResDimensions(resolutionData);
    }, [resolutionData]);

    // Fetch the resolution JSON data
    // Then find within it the entry that matches the name provided by resolutionData, as selected in our form
    async function getResDimensions(resolutionData) {
        if (open){
            let fetchDetails = {
                method: "POST",
                body: JSON.stringify({'resName': resolutionData}),
                headers: { "Content-type": "application/json; charset=UTF-8" , 'X-Project-ID': projectContext?.project_db }
            };
            let request = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/fdlresdetails/`, fetchDetails);
            let result = await request.json();
            setResolutionX(result['GET'][0]);
            setResolutionY(result['GET'][1]);
        }
    }

    async function handleSubmit(event) {
        event.preventDefault();

        const data = new FormData(event.currentTarget);
        let newKey = 'Error, no label entered';
        let newData = {};
        let cameraID;
        for (const entry of data.entries()) {
            if (entry != undefined) {
                // First two if statements check to see if Source Canvas ID is empty, and if so assign it the value of Camera ID as per FDL spec
                if (entry[0] === 'Camera ID') {
                    cameraID = entry[1]
                    newKey = entry[1]
                    newData[`${entry[0]}`] = entry[1]
                }
                // else if (entry[0] === 'Source Canvas ID') {
                //     if (entry[1] === '') {
                //         entry[1] = cameraID
                //     }
                // }
                else{
                    newData[`${entry[0]}`] = entry[1]
                }
            }
        };

     
        let fetchDetails = {
            method: "POST",
            body: JSON.stringify({
                'dataType': 'canvas', 
                'modal': true,
                'data': newData,
                'oldLabel': oldLabel,
                'oldID': oldID,
                'allCameraData': cameraData,
                'action': 'create'
            }),
            headers: { "Content-type": "application/json; charset=UTF-8", 'X-Project-ID': projectContext?.project_db  }
        };
            
        let response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/fdlvalidateinputone/`, fetchDetails);
        let result = await response.json();

        if(result['passed'] === 'fail'){
            setFormErrorText(result['reason'])
        }
        else{
            // Delete the existing Canvas 
            const updatedData = { ...cameraData };
            delete updatedData[cameraName];
            setCameraData(updatedData)
            // Insert new or updated data
            updatedData[newKey] = newData;
            setCameraData(updatedData);
            setFormErrorText('')
            closeModal()
        }     
    }

    function closeModal(){
        handleClose()
        setFormErrorText('')
    }



    return (
        <Modal
            open={open}
            onClose={closeModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={modalPosition}
        >
            <Box sx={modalContainer}>
                <h2>Edit {cameraName}</h2>
                <Box component='form' onSubmit={handleSubmit}
                    autoComplete="off"
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap'
                    }}
                >
                    <FormField
                        name='Camera Label'
                        label='Canvas Label'
                        fontSize='10px'
                        units=''
                        placeholder='Example Canvas'
                        selectTypeVariant='manf'
                        defaultValue={oldLabel}
                        open={open}
                    />
                    <FormField
                        name='Camera ID'
                        label='Canvas ID'
                        fontSize='10px'
                        units=''
                        placeholder='example_camvas'
                        selectTypeVariant='manf'
                        validationType='id'
                        required
                        defaultValue={canvases["Camera ID"]}
                        open={open}
                    />
                    <FormField
                        name='Source Canvas ID'
                        label='Source Canvas ID'
                        fontSize='10px'
                        units=''
                        placeholder='a_different_canvas'
                        selectTypeVariant='manf'
                        validationType='id'
                        defaultValue={canvases["Source Canvas ID"]}
                        open={open}
                    />
                    {/* ================================================================================= */}
                    <FormField
                        name='Camera Manufacturer'
                        updateParentStateRecord={setManufacturer}
                        label='Camera Manufacturer'
                        fontSize='10px'
                        units=''
                        type='select'
                        selectTypeVariant='manf'
                        defaultValue={canvases["Camera Manufacturer"]}
                        open={open}
                    />
                    <FormField
                        name='Camera Model'
                        updateParentStateRecord={setCamera}
                        label='Camera Model'
                        fontSize='10px'
                        units=''
                        type='select'
                        selectTypeVariant='camera'
                        dataSuperset={manufacturer}
                        defaultValue={canvases["Camera Model"]}
                        open={open}
                    />
                    <FormField
                        name='Camera Resolution'
                        updateParentStateRecord={setResolutionData}
                        label='Camera Resolution'
                        fontSize='10px'
                        units=''
                        type='select'
                        selectTypeVariant='res'
                        dataSuperset={camera}
                        defaultValue={canvases['Camera Resolution']}
                        open={open}
                        // dataSuperset={canvases["Camera Model"]}
                        // defaultValue={canvases["Camera Resolution"]}
                    />
                    {/* ================================================================================= */}
                    <FormField
                        name='Resolution X'
                        updateParentStateRecord={setResolutionX}
                        pair={true}
                        label='Resolution X'
                        fontSize='10px'
                        units='px'
                        placeholder='1080'
                        required
                        validationType='number'
                        defaultValue={canvases["Resolution X"]}
                        value={resolutionX}
                        open={open}
                    />
                    <FormField
                        name='Resolution Y'
                        updateParentStateRecord={setResolutionY}
                        pair={true}
                        label='Resolution Y'
                        fontSize='10px'
                        units='px'
                        placeholder='1920'
                        required
                        validationType='number'
                        defaultValue={canvases["Resolution Y"]}
                        value={resolutionY}
                        open={open}
                    />
                    <FormField
                        name='Effective Res X'
                        pair={true}
                        label='Effective Res X'
                        fontSize='10px'
                        units='px'
                        placeholder='1000'
                        updateParentStateRecord={setEffectiveX}
                        validationType='number'
                        defaultValue={canvases["Effective Res X"]}
                        open={open}
                        // value={effectiveX}
                    />
                    <FormField
                        name='Effective Res Y'
                        pair={true}
                        label='Effective Res Y'
                        fontSize='10px'
                        units='px'
                        placeholder='1800'
                        updateParentStateRecord={setEffectiveY}
                        validationType='number'
                        defaultValue={canvases["Effective Res Y"]}
                        open={open}
                        // value={effectiveY}
                    />
                    {/* <FormField
                        name='Effective Anchor X'
                        pair={true}
                        type='number'
                        label='Effective Anchor X'
                        fontSize='10px'
                        units='px'
                        placeholder=''
                        disabled
                        dependsOn={[effectiveX, effectiveY]}
                    />
                    <FormField
                        name='Effective Anchor Y'
                        pair={true}
                        type='number'
                        label='Effective Anchor Y'
                        fontSize='10px'
                        units=''
                        placeholder=''
                        disabled
                        dependsOn={[effectiveX, effectiveY]}
                    /> */}
                    <FormField
                        name='Photosite X'
                        pair={true}
                        type='number'
                        label='Photosite X'
                        fontSize='10px'
                        units=''
                        placeholder='1080'
                        validationType='number'
                        defaultValue={canvases["Photosite X"]}
                        open={open}
                    />
                    <FormField
                        name='Photosite Y'
                        pair={true}
                        label='Photosite Y'
                        fontSize='10px'
                        units=''
                        placeholder='1920'
                        validationType='number'
                        defaultValue={canvases["Photosite Y"]}
                        open={open}
                    />
                    <FormField
                        name='Sensor Physical Dimensions X'
                        pair={true}
                        label='Sensor Physical Dimensions X'
                        fontSize='10px'
                        units='mm'
                        placeholder='42'
                        validationType='decimal'
                        defaultValue={canvases["Sensor Physical Dimensions X"]}
                        open={open}
                    />
                    <FormField
                        name='Sensor Physical Dimensions Y'
                        pair={true}
                        label='Sensor Physical Dimensions Y'
                        fontSize='10px'
                        units='mm'
                        placeholder='68.5'
                        validationType='decimal'
                        defaultValue={canvases["Sensor Physical Dimensions Y"]}
                        open={open}
                    />
                    <FormField
                        name='Anamorphic Squeeze'
                        label='Anamorphic Squeeze'
                        fontSize='10px'
                        units=''
                        placeholder='1.5'
                        validationType='decimal'
                        defaultValue={canvases["Anamorphic Squeeze"]}
                        updateParentStateRecord={setAnamorphic}
                        open={open}
                    />
                    <Box style={bottomButtonContainer}>
                        <FdlButton type='submit' text="Confirm Changes"></FdlButton>
                        <FdlButton style={cancelButtonStyle} text="Cancel" onClick={handleClose}></FdlButton>
                    </Box>
                    <Alert severity='error' style={formErrorTextStyle}>
                        <AlertTitle>Form submission error:</AlertTitle>
                        {formErrorText}
                    </Alert>
                </Box>
            </Box>
        </Modal>
    );
}